export default __webpack_public_path__ + "static/skillmeter-world4-9f8ab582d10f96f49ea5488dc5d55b91.png";